module.exports = __webpack_public_path__ + "static/img/tj6.eb11aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj6.png
// module id = xDk0
// module chunks = 0